// extracted by mini-css-extract-plugin
export default {"container":"StackPill_container__aox6M","logo":"StackPill_logo__lWM2R","progress_band":"StackPill_progress_band__duKvp"};